import React, {Component} from "react";
import {connect} from "react-redux";
import {Avatar, Popover} from "antd";
// import {userSignOut} from "appRedux/actions/Auth";
import AuthActions from "../../appRedux/redux/Auth";
import {Link } from 'react-router-dom'

class UserProfile extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {user, history} = this.props;
    const userMenuOptions = (
      <ul className="gx-user-popover">
        <li><Link to={user.rol === 'client' ? 'clientDashboard/editProfile' : 'mayorDashboard/editProfile'}>Mi cuenta</Link></li>
        <li onClick={() => this.props.userSingOut()}>Cerrar Sesion</li>
      </ul>
    );

    return (

      <div className="gx-flex-row gx-align-items-center gx-mb-4 gx-avatar-row">
        <Popover placement="bottomRight" content={userMenuOptions} trigger="click">
          <Avatar src={this.props.image}
                  className="gx-size-40 gx-pointer gx-mr-3" alt=""/>
          <span className="gx-avatar-name">{this.props.userName}<i
            className="icon icon-chevron-down gx-fs-xxs gx-ml-2"/></span>
        </Popover>
      </div>

    )

  }
}
const mapStateToProps = ({user, routing}) => {
  return {
    ...user,
    routing,
  }
}

export default connect(mapStateToProps, { userSingOut: AuthActions.userSignOut })(UserProfile);
